import React from 'react';
import PropTypes from 'prop-types';
import { Row, Form, Button } from 'react-bootstrap';
import { withRouter } from 'react-router-dom';
const uuid = require('uuid');
const get = require('lodash/get');

const Globals = require('../../../../app/globals');
const Strings = require('../../../../app/shared/Strings');
const KeyboardUtil = require('../../util/keyboard');
const ValidateUtil = require('../../util/ValidateUtil');
const UriUtil = require('../../util/UriUtil');
const SignInStore = require('../../stores/SignInStore');
const RegisterActions = require('../../actions/RegisterActions');
const RegisterStore = require('../../stores/register_store_reflux');
import Navigator from '../../Navigator';
import ErrorBox from '../common/ErrorBox';
import LogoPanelHeader from './LogoPanelHeader';
import SignedOutFooter from './SignedOutFooter';
import { SignedOutVerifyPanel } from './SignedOutPromoPanel';

const propTypes = {
    groupRegister: PropTypes.bool,
    history: PropTypes.object.isRequired,
    location: PropTypes.shape({
        search: PropTypes.string,
    }).isRequired,
};

const defaultProps = {
    groupRegister: false,
}

class RegisterFull extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            registerStoreState: RegisterStore.getState(),
            signinStoreState: SignInStore.getState(),
            firstName: "",
            lastName: "",
            password: "",
            passwordConfirm: "",
            submissionSuccess: false,
            message: "",
            key: "",
            dispName: "",
            affiliation: "",
            buildQuestion: "",
            // receiveUpdates: true, // TODO?
            // receiveNewsletter: true, // TODO?
            getEmailActionId: null,
            actionID: null,
            ...ValidateUtil.getDefaultValidationState(),
        };

        this.firstNameOnChange = this.firstNameOnChange.bind(this);
        this.lastNameOnChange = this.lastNameOnChange.bind(this);
        this.passwordOnChange = this.passwordOnChange.bind(this);
        this.passwordConfirmOnChange = this.passwordConfirmOnChange.bind(this);
        this.dispNameOnChange = this.dispNameOnChange.bind(this);
        this.affiliationOnChange = this.affiliationOnChange.bind(this);
        this.buildQuestionOnChange = this.buildQuestionOnChange.bind(this);
        // this.receiveUpdatesOnChange = this.receiveUpdatesOnChange.bind(this);
        // this.receiveNewsletterOnChange = this.receiveNewsletterOnChange.bind(this);
        this.handleKeyDown = this.handleKeyDown.bind(this);
        this.registerHandler = this.registerHandler.bind(this);
        this.getEmail = this.getEmail.bind(this);
        this.unsubscribes = [
            RegisterStore.listen(this.onRegisterStoreChange.bind(this)),
            SignInStore.listen(this.onSignInStoreChange.bind(this))
        ];
    }

    componentDidMount(){
        const key = UriUtil.parseLocationSearchString(this.props.location).key;
        if (!key) {
            this.props.history.push('/signin');
            return;
        }
        
        if (!this.getEmail()) {
            const getEmailActionId = uuid.v4();
            this.setState({ getEmailActionId: getEmailActionId }, () => {
                RegisterActions.userInfo(getEmailActionId, { secret: key });
            });
        }
    }

    componentWillUnmount() {
        this.unsubscribes.forEach(u => u());
    }

    onRegisterStoreChange(state){
        let additionalState = {};
        if (!!this.state.actionID && this.state.actionID === state.action.id) {
            if (state.initialized && !state.action.error){
                additionalState = { ...additionalState, submissionSuccess: true }; 
            }
            else {
                console.warn(state.initialized, !!state.action.id, !state.action.error);
            }

            additionalState = { ...additionalState, actionID: null, ...ValidateUtil.getUpdatedState(this.state.actionID, state) };
        }
        else if (!!this.state.getEmailActionId && this.state.getEmailActionId === state.action.id) {
            if (!!state.action.error) {
                console.warn(state.action.error);
            }

            additionalState = { ...additionalState, getEmailActionId: null };
        }

        this.setState({ registerStoreState: state, ...additionalState });
    }

    onSignInStoreChange(state) {
        if (this.state.submissionSuccess && state.initializedLocal) {
            const query = UriUtil.parseLocationSearchString(this.props.location);
            const redirectTo = query[Globals.uri.query.REDIRECT_TO] || null;
            const redirectToPath = query[Globals.uri.query.REDIRECT_TO_PATH] || null;
            const hash = query.hash || null;
            switch (redirectTo) {
                case 'course_instance_direct': {
                    window.location.href = `/course_instance/${hash}`;
                    break;
                }
                default: {
                    if (!!redirectToPath) {
                        Navigator._goTo(this.props.history, redirectToPath, { replace: true });
                    }
                    else {
                        Navigator.goToDashboardHome(this.props.history, state.userInfo.id, { replace: true });
                    }
                }
            }

            return;
        }

        this.setState({ signinStoreState: state });
    }

    firstNameOnChange(e){
        this.setState({ firstName: e.target.value });
    }

    lastNameOnChange(e){
        this.setState({ lastName: e.target.value });
    }

    passwordOnChange(e){
        this.setState({ password: e.target.value });
    }

    passwordConfirmOnChange(e){
        this.setState({ passwordConfirm: e.target.value });
    }

    dispNameOnChange(e){
        this.setState({ dispName: e.target.value });
    }

    affiliationOnChange(e) {
        this.setState({ affiliation: e.target.value });
    }

    buildQuestionOnChange(e) {
        this.setState({ buildQuestion: e.target.value });
    }

    /*receiveUpdatesOnChange(e) {
        this.setState({ receiveUpdates: e.target.checked });
    }

    receiveNewsletterOnChange(e) {
        this.setState({ receiveNewsletter: e.target.checked });
    }*/

    handleKeyDown(e) {
        if (KeyboardUtil.isEnterKey(e.keyCode)) {
            this.registerHandler();
        }
    }

    registerHandler() {
        const actionID = uuid.v4();
        this.setState({ actionID: actionID }, () => {
            RegisterActions.register(
                actionID,
                {
                    firstName: this.state.firstName,
                    lastName: this.state.lastName,
                    password: this.state.password,
                    passwordConfirm: this.state.passwordConfirm,
                    displayName: this.state.dispName,
                    affiliation: this.state.affiliation,
                    buildQuestion: this.state.buildQuestion,
                    // receiveUpdates: this.state.receiveUpdates,
                    // receiveNewsletter: this.state.receiveNewsletter,
                    key: UriUtil.parseLocationSearchString(this.props.location).key,
                }
            );
        });
    }

    getEmail() {
        return get(this.state.registerStoreState, ['userInfo', 'email'], '');
    }

    render() {
        return (
            <div className="fill signed-out--new">
                <div className="container rel-centered-v">
                    <div className="signedOutDual">
                        <SignedOutVerifyPanel />
                        <div className="signedOutDual__form">
                            <ErrorBox error={this.state.error} />
                            <Form>
                                <Row>
                                    <div className="col-12 col-sm-6">
                                        <Form.Group controlId="register-password">
                                            <Form.Label>{Strings['en'].signed_out.register_new.PW_LBL}</Form.Label>
                                            <Form.Control
                                                type="password"
                                                aria-label={Strings['en'].signed_out.register_new.PW_LBL}
                                                placeholder={Strings['en'].signed_out.register_new.PW_PH}
                                                onChange={this.passwordOnChange}
                                                onKeyDown={this.handleKeyDown}
                                                isInvalid={ValidateUtil.isInvalid(this.state, 'password')}
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-12 col-sm-6">
                                        <Form.Group controlId="register-password-confirm">
                                            <Form.Label>{Strings['en'].signed_out.register_new.PW_CONFIRM_LBL}</Form.Label>
                                            <Form.Control
                                                type="password"
                                                aria-label={Strings['en'].signed_out.register_new.PW_CONFIRM_LBL}
                                                placeholder={Strings['en'].signed_out.register_new.PW_CONFIRM_PH}
                                                onChange={this.passwordConfirmOnChange}
                                                onKeyDown={this.handleKeyDown}
                                                isInvalid={ValidateUtil.isInvalid(this.state, 'passwordConfirm')}
                                            />
                                        </Form.Group>
                                    </div>
                                </Row>
                                <Row>
                                    <div className="col-12 col-sm-6">
                                        <Form.Group controlId="register-first-name">
                                            <Form.Label>{Strings['en'].signed_out.register_new.FIRST_LBL}</Form.Label>
                                            <Form.Control
                                                type="text"
                                                aria-label={Strings['en'].signed_out.register_new.FIRST_LBL}
                                                placeholder={Strings['en'].signed_out.register_new.FIRST_PH}
                                                onChange={this.firstNameOnChange}
                                                onKeyDown={this.handleKeyDown}
                                                maxLength={Globals.users.profile.SIZE_FIRST}
                                                isInvalid={ValidateUtil.isInvalid(this.state, 'firstName')}
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-12 col-sm-6">
                                        <Form.Group controlId="register-last-name">
                                            <Form.Label>{Strings['en'].signed_out.register_new.LAST_LBL}</Form.Label>
                                            <Form.Control
                                                type="text"
                                                aria-label={Strings['en'].signed_out.register_new.LAST_LBL}
                                                placeholder={Strings['en'].signed_out.register_new.LAST_PH}
                                                onChange={this.lastNameOnChange}
                                                onKeyDown={this.handleKeyDown}
                                                maxLength={Globals.users.profile.SIZE_LAST}
                                                isInvalid={ValidateUtil.isInvalid(this.state, 'lastName')}
                                            />
                                        </Form.Group>
                                    </div>
                                </Row>
                                <Row>
                                    <div className="col-12 col-sm-6">
                                        <Form.Group controlId="register-display-name">
                                            <Form.Label>{Strings['en'].signed_out.register_new.DISP_LBL}</Form.Label>
                                            <Form.Control
                                                type="text"
                                                aria-label={Strings['en'].signed_out.register_new.DISP_LBL}
                                                placeholder={Strings['en'].signed_out.register_new.DISP_PH}
                                                onChange={this.dispNameOnChange}
                                                onKeyDown={this.handleKeyDown}
                                                maxLength={Globals.users.profile.SIZE_DISPLAY}
                                                isInvalid={ValidateUtil.isInvalid(this.state, 'displayName')}
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-12 col-sm-6">
                                        <Form.Group controlId="register-email">
                                            <Form.Label>{Strings['en'].signed_out.register_new.EMAIL_LBL}</Form.Label>
                                            <Form.Control
                                                type="text"
                                                aria-label={Strings['en'].signed_out.register_new.EMAIL_LBL}
                                                placeholder={this.getEmail()}
                                                readOnly
                                            />
                                        </Form.Group>
                                    </div>
                                </Row>
                                <Row>
                                    <div className="col-12">
                                        <Form.Group controlId="register-affiliation">
                                            <Form.Label>{Strings['en'].signed_out.register_new.PRO_AFF_LBL}</Form.Label>
                                            <Form.Control
                                                type="text"
                                                aria-label={Strings['en'].signed_out.register_new.PRO_AFF_LBL}
                                                placeholder={Strings['en'].signed_out.register_new.PRO_AFF_PH}
                                                onChange={this.affiliationOnChange}
                                                onKeyDown={this.handleKeyDown}
                                                maxLength={Globals.users.profile.SIZE_AFFILIATION}
                                                isInvalid={ValidateUtil.isInvalid(this.state, 'affiliation')}
                                            />
                                        </Form.Group>
                                    </div>
                                </Row>
                                <Row>
                                    <div className="col-12">
                                        <Form.Group controlId="register-buildQuestion">
                                            <Form.Label>{Strings['en'].signed_out.register_new.BUILD_Q_LBL}</Form.Label>
                                            <Form.Control
                                                as="textarea"
                                                aria-label={Strings['en'].signed_out.register_new.BUILD_Q_LBL}
                                                placeholder={Strings['en'].signed_out.register_new.BUILD_Q_PH}
                                                onChange={this.buildQuestionOnChange}
                                                onKeyDown={this.handleKeyDown}
                                                maxLength={Globals.users.profile.SIZE_BUILD_QUESTION}
                                                isInvalid={ValidateUtil.isInvalid(this.state, 'buildQuestion')}
                                            />
                                        </Form.Group>
                                    </div>
                                </Row>
                                <div className="signedOutDual__buttonRow margin-top-lg">
                                    <Button
                                        className="btn-register-full"
                                        disabled={this.state.submissionSuccess || !!this.state.actionID || this.state.registrationComplete}
                                        onClick={this.registerHandler}
                                    >
                                        {Strings['en'].signed_out.register_new.VERIFY_BTN_LBL}
                                    </Button>
                                </div>
                            </Form>
                        </div>
                    </div>
                </div>
                <SignedOutFooter />
            </div>
        );
    }
}

RegisterFull.propTypes = propTypes;
RegisterFull.defaultProps = defaultProps;

export default withRouter(RegisterFull);